import type { SVGProps } from 'react';

const SvgEditBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M13 5.99997L18 11M4 19V15.4142C4 15.149 4.10536 14.8946 4.29289 14.7071L15.2929 3.70708C15.6834 3.31655 16.3166 3.31655 16.7071 3.70708L20.2929 7.29286C20.6834 7.68339 20.6834 8.31655 20.2929 8.70708L9.29289 19.7071C9.10536 19.8946 8.851 20 8.58579 20H5C4.44772 20 4 19.5523 4 19Z'
      stroke='currentColor'
      strokeWidth={2}
    />
  </svg>
);
export default SvgEditBd;
